import { useMemo } from 'react';
import { createStaticDataProvider } from '@adv-frontend/data-provider';
import { createFilterSelectWithSuggest, OperatorType } from '@adv-frontend/filters';
import { type OpenApiSchemaABCCombinedCategory } from '#shared/api/schema';
import { ABC_COMBINED_CATEGORIES } from '#shared/lib/abcAnalysis';
import { trimAndLowerString } from '#shared/lib/string';
import { ABC_CATEGORIES_FILTER_ID, ABC_CATEGORIES_FILTER_TITLE } from '../abcAnalysis';

type AbcCategoryItem = {
    id: OpenApiSchemaABCCombinedCategory;
    label: OpenApiSchemaABCCombinedCategory;
};

const items: AbcCategoryItem[] = ABC_COMBINED_CATEGORIES.map((category) => {
    return {
        id: category,
        label: category,
    };
});

export const createAbcCategoriesFilter = () =>
    createFilterSelectWithSuggest<string, AbcCategoryItem>({
        id: ABC_CATEGORIES_FILTER_ID,
        title: ABC_CATEGORIES_FILTER_TITLE,
        operators: [OperatorType.Eq],
        suggestProps: {
            dataProvider: function Component(props) {
                const searchString = trimAndLowerString(props.queryArg.searchValue);
                const filteredItems = useMemo(
                    () => items.filter((item) => trimAndLowerString(item.label).includes(searchString)),
                    [searchString]
                );
                const dataProvider = useMemo(() => createStaticDataProvider(filteredItems), [filteredItems]);

                return props.children(dataProvider);
            },
            renderSelectListItem: ({ item }) => item.label,
            renderFilterChipsItem: ({ item }) => item.label,
        },
    });
